
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document/service",
      function () {
        return require("private-next-pages/document/service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document/service"])
      });
    }
  